// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"a81befe3","269":"52681d8e","289":"0ffd0ded","453":"ea7afc41","504":"49689af3","513":"55618280","530":"864e962c","542":"e1af9504","555":"24f29950","630":"1fe25fc4","657":"4c31d9c3","667":"379448ed","766":"be45d6b2","900":"a94b68b5","980":"8ab745fa"}[chunkId] + ".chunk.js";
};